import "./scss/style.scss";

import "slick-carousel";
import "./js/sticky.min.js";
import "./js/script.js";
